import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest

  const refresh = useCallback(async () => {
    try {
      const { data } = await API.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false); // 401 saat guest adalah kondisi normal
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (identifier, password, accessCode = "") => {
    const { data } = await API.post("/auth/login", { identifier, password, access_code: accessCode });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await API.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, logout, refresh, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
